
import React, { SyntheticEvent, useState } from "react";
import { Slider } from "@mui/material";
import { 
  ProjectState, 
  updateProjectSliceLength,
} from "../../../../shared";

type Props = {
  project: ProjectState
}

function SliceControl({ project }: Props) {
  const [value, setValue] = useState(
    project.sliceLength || 0
  );

  const onChange = async (
    event: Event | SyntheticEvent<Element, Event>, 
    value: number | number[]
  ) => {
    const isNumberVal = typeof value === "number"
    let val = isNumberVal ? value : value[0];
    const radius = parseFloat(val.toFixed(1));
    setValue(radius);
  }

  const onChangeCommitted = async (
    event: Event | SyntheticEvent<Element, Event>, 
    value: number | number[]
  ) => {
    const isNumberVal = typeof value === "number"
    let val = isNumberVal ? value : value[0];
    const sliceLength = parseFloat(val.toFixed(1));
    updateProjectSliceLength(project, sliceLength);
}

  return (
    <div style={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
    }}>
        Slice
        <Slider
            min={0}
            value={value}
            defaultValue={0}
            step={1}
            max={Math.min(40, project.layers.length)}
            aria-label="Default" 
            valueLabelDisplay="auto"
            onChange={onChange}
            onChangeCommitted={onChangeCommitted}
        />
    </div>
  );
}

export default SliceControl;